import React, { useState, useEffect, useContext } from 'react';
import './scss/style.scss';
import './css/style.css';
import './css/header.css';
import './css/login.css';
import './css/custom.css';
//import './config/bootstrap.scss';
//import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Container } from 'react-bootstrap';
import VersionCheck from './components/BodyElements/VersionCheck';


/** pages */
import Login from './pages/login/index';
import Recover from './pages/login/recover';
import Reset from './pages/login/reset';
import Logout from './pages/user/logout';
import Settings from './pages/user/settings';
import NotFound from './pages/not_found';
import License from './pages/license';
import Privacy from './pages/privacy';
import Cookie from './pages/cookie';
import Home from './pages/index';
import NotAuthorized from './pages/not_authorized';
import Entry from './pages/entry/index';
import Collection from './pages/collection/index';
import Profile from './pages/profile/index';
import Cart from './pages/cart/index';
import Soon from './pages/soon/soon';
import Congratulazioni from './pages/thanksyou/index';
import ConfermaOrdine from './pages/conferma_ordine/index';
import Search from './pages/search/index.tsx';
import PrivacyPolicy from './pages/privacy_policy/index.js';
import TermsAndConditions from './pages/terms_and_conditions/index.js';



/** core & components */
import { LanguageProvider } from './core/language-provider';
import { LoginManager } from './core/login-manager';
import { DataManager } from './core/data-manager';
import HeaderBlock from './components/BodyElements/HeaderBlock';
import FooterBlock from './components/BodyElements/FooterBlock';
import ConnectionStatus from './components/BodyElements/ConnectionStatus';


import { Helmet } from "react-helmet";
import { settings } from './config/settings';
import Contattaci from './pages/contattaci';
import Registrati from './pages/registrati';
import Dettaglio from './pages/dettaglio';
import Collezioni from './pages/collezioni';
import HomeLiving from './pages/home-living';
import RegistrazioneClienti from './pages/registrazione_clienti';
import SearchContext from "./pages/search/searchContext.tsx";
import { CartContext , CartContextProvider } from './contexts/CartContext.tsx';





function App() {

    library.add(fas)

    const [isLogged, setIsLogged] = useState(null);
    const [language, setLanguage] = useState('ita');
    const [userInfo, setUserInfo] = useState(null);


    useEffect(() => {
        async function init() {
            var response = await LoginManager.checkLogin()
            console.log('checkLogin', response)
            setIsLogged(response)
            setUserInfo(LoginManager.getUserInfo());
        }

        init()
        detectSidChange()
    }, []);

    async function detectSidChange() {
        var sessionId = LoginManager.registerChangeSid(async function () {
            var response = await LoginManager.checkLogin()
            console.log('CheckLogin after sid changed', response)
            setIsLogged(response);
            setUserInfo(LoginManager.getUserInfo());
        })
        console.log('--- SESSION ID ' + sessionId + ' ---')
    }


    useEffect(() => {
        LanguageProvider.setCurrentLanguage(language)
    }, [language]);


    if (isLogged === null) {
        return (
            <>
                <p>Loading...</p>
                <ConnectionStatus />
            </>
        )
    }
    else if (isLogged === false) {
        return (
            <Router basename={'/'} >
                <Helmet>
                    <meta charSet="utf-8" />
                    <title>{settings.title}</title>
                    <meta name="description" content="React application" />
                </Helmet>
                <div id='app-container'>
                    <Routes>
                        <Route exact path='/' element={<Login />} /> {/* default page */}
                        <Route exact path='/recover' element={<Recover />} />
                        <Route exact path='/reset' element={<Reset />} />
                        <Route path='/license' element={<License />} />
                        <Route path="*" element={<NotFound />} /> {/* 404 page */}
                        <Route path='/registrati' element={<Registrati />} />
                        <Route path='/congratulazioni' element={<Registrati />} />
                        <Route path='/registrazione_clienti' element={<RegistrazioneClienti />} />
                        
                        <Route path='/privacy-policy' element={<PrivacyPolicy />} />
                        <Route path='/terms-and-conditions' element={<TermsAndConditions />} />
                        
                    </Routes>
                </div>
                <ToastContainer
                    position="bottom-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="light"
                />
                <VersionCheck />
            </Router>
        )
    }
    else {
        if (userInfo && userInfo.authorized === 1) {
            return (
                <CartContextProvider>
                    <SearchContext>
                        <Router basename={'/'}>
                            <Helmet>
                                <meta charSet="utf-8" />
                                <title>{settings.title}</title>
                                <meta name="description" content="React application" />
                            </Helmet>
                            <Container fluid  id="main-container" className=' px-0'>
                                <HeaderBlock/>
                                <div id='app-container'>
                                    <Routes>
                                        <Route path="*" element={<NotFound />} /> {/* 404 page */}
                                        <Route exact path='/' element={<Home />} /> {/* default page */}
                                        <Route path='/license' element={<License />} />
                                        <Route path='/privacy' element={<Privacy />} />
                                        <Route path='/cookie' element={<Cookie />} />
                                        <Route path='/logout' element={<Logout />} />
                                        <Route path='/settings' element={<Settings />} />
                                        <Route path='/collezione/:k' element={<Collection />} />
                                        <Route path='/contattaci' element={<Contattaci />} />
                                        <Route path='/profile' element={<Profile />} />
                                        <Route path='/cart' element={<Cart />} />
                                        <Route path='/dettaglio/:k'  element={<Dettaglio/>} />
                                        <Route path='/soon' element={<Soon />} />
                                        <Route path='/collezioni' element={<Collezioni />} />
                                        <Route path='/home-living' element={<HomeLiving />} />
                                        <Route path='/grazie' element={<Congratulazioni />} />
                                        <Route path='/invio_riuscito' element={<ConfermaOrdine />} />
                                        <Route path='/registrazione_clienti' element={<RegistrazioneClienti />} />
                                        <Route path='/cerca' element={<Search />} />

                                        <Route path='/privacy-policy' element={<PrivacyPolicy />} />
                                        <Route path='/terms-and-conditions' element={<TermsAndConditions />} />
                                        
                                        <Route path="/entry/:k" element={<Entry />} />
                                    </Routes>
                                </div>
                                <FooterBlock />
                                <ToastContainer
                                    position="bottom-right"
                                    autoClose={5000}
                                    hideProgressBar={false}
                                    newestOnTop={false}
                                    closeOnClick
                                    rtl={false}
                                    pauseOnFocusLoss
                                    draggable
                                    pauseOnHover
                                    theme="light"
                                />
                            </Container>
                        </Router>
                        <VersionCheck />
                    </SearchContext>
                </CartContextProvider>
            );
        }
        else {
            return (
                <Router basename={'/'}>
                    <Helmet>
                        <meta charSet="utf-8" />
                        <title>{settings.title}</title>
                        <meta name="description" content="React application" />
                    </Helmet>
                    <Container fluid  id="main-container" className='pt-2'>
                        <HeaderBlock />
                        <div id='app-container'>
                            <Routes>
                                <Route path="*" element={<NotAuthorized />} /> {/* 404 page */}
                                <Route exact path='/' element={<NotAuthorized />} /> {/* default page */}
                            </Routes>
                        </div>
                        <FooterBlock />
                        <ToastContainer
                            position="bottom-right"
                            autoClose={5000}
                            hideProgressBar={false}
                            newestOnTop={false}
                            closeOnClick
                            rtl={false}
                            pauseOnFocusLoss
                            draggable
                            pauseOnHover
                            theme="light"
                        />
                    </Container>
                    <VersionCheck />
                </Router>
            );
        }

    }

}

export default App;